<template>
    <div>
        <div>* Place mouse over the select or input on the left to see the options of input types. Input type can switch among constant, field, enumerate and instance.</div>
        <div>* An instance can be referred as a parameter by another instance that placed beneath itself.</div>
        <div>* Please use Chrome for now.</div>
        <div v-for="(i, index) in allInsts">
            <expression-atom :name="`Inst-${index+1}`" :variables="fields" :instances="providedInsts[index]" @alter="alterInst($event, index)"></expression-atom>
            <expression-note :instance="i" mode="code" prefix="MYSQL: "></expression-note>
            <expression-note :instance="i" mode="display" prefix="Expl: "></expression-note>
        </div>
        <div style="cursor: pointer; font-size: 1.5em; margin-top: 40px; margin-bottom: 40px" @click="addInst">+ Add a new instance</div>
        <div style="height: 4px; border-bottom: 1px solid #ddd"></div>
        <div style="height: 4px; margin-top: 30px"></div>
        <div>* Operators can be customized, click to add 「cubic」and return above to see what new will respond the number type of inputs.</div>
        <div style="text-align: left; margin-top: 20px">
            <div style="text-indent: 40%">new Template({</div>
            <div style="text-indent: 44%">name: 'cubic',</div>
            <div style="text-indent: 44%">context: 'mysql',</div>
            <div style="text-indent: 44%">templateDisplay: 'cubic($1)',</div>
            <div style="text-indent: 44%">templateCode: '$1*$1*$1',</div>
            <div style="text-indent: 44%">resultDataType: 'number',</div>
            <div style="text-indent: 44%">params: {</div>
            <div style="text-indent: 48%">$1: new Parameter({</div>
            <div style="text-indent: 52%">dataType: 'number'</div>
            <div style="text-indent: 48%">})</div>
            <div style="text-indent: 44%">}</div>
            <div style="text-indent: 40%">}).as('cubic');</div>
        </div>
        <div style="cursor: pointer; font-size: 1.5em; margin-top: 40px; margin-bottom: 40px" @click="addOper">+ Add operator「cubic」</div>
    </div>
</template>

<script>

    import ExpressionAtom from '../../mould-v/clause/ExpressionAtom'
    import ExpressionNote from '../../mould-v/explain/ExpressionNote'
    import { OP, Template, Parameter, Table, Field, Enum, Operators, i18n } from '../../mould';

    export default {

        name: 'demo-en',

        components: {ExpressionAtom, ExpressionNote},

        data(){
            return {
                fields: [],
                allInsts: [null, null],
                providedInsts: [],
                added: false
            }
        },

        computed: {

        },

        mounted(){

            i18n.switchTo('en');
            Operators.activateContext('mysql');

            let allData = [
                new Table({
                    name: 'USER_INFO',
                    label: 'users\' basic info'
                }).addFields([
                    new Field({
                        name: 'USER_ID',
                        label: 'user id',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'USER_NAME',
                        label: 'user name',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'AGE',
                        label: 'age',
                        dataType: 'number',
                        distributeType: 'metrics',
                        unit: 'year'
                    }),
                    new Field({
                        name: 'GENDER',
                        label: 'gender',
                        dataType: 'number',
                        distributeType: 'category',
                    }).addEnums([
                        new Enum({
                            code: 0,
                            label: 'male'
                        }),
                        new Enum({
                            code: 1,
                            label: 'female'
                        })
                    ])
                ]),

                new Table({
                    name: 'COMMODITY_INFO',
                    label: 'commodities\' info'
                }).addFields([
                    new Field({
                        name: 'COMMODITY_ID',
                        label: 'commodity id',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'COMMODITY_NAME',
                        label: 'commodity name',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'UNIT_PRICE',
                        label: 'unit price',
                        dataType: 'number',
                        distributeType: 'metrics',
                        unit: 'USD'
                    }),
                ]),

                new Table({
                    name: 'COMMODITY_PURCHASE_LOG',
                    label: 'commodities\' transaction'
                }).addFields([
                    new Field({
                        name: 'COMMODITY_ID',
                        label: 'commodity id (disabled)',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'USER_ID',
                        label: 'user id (disabled)',
                        dataType: 'string'
                    }),
                    new Field({
                        name: 'QUANTITY',
                        label: 'quantity',
                        dataType: 'number',
                        distributeType: 'metrics',
                        unit: 'unit'
                    }),
                    new Field({
                        name: 'DISCOUNT',
                        label: 'discount',
                        dataType: 'string',
                        distributeType: 'category',
                    }).addEnums([
                        new Enum({
                            code: 'none',
                            label: 'no discount'
                        }),
                        new Enum({
                            code: '0.8-all',
                            label: '20% off for total'
                        }),
                        new Enum({
                            code: '0.5-sec',
                            label: '50% off for the second'
                        }),
                        new Enum({
                            code: 'free',
                            label: 'free'
                        })
                    ])
                ])
            ];


            this.fields = [];
            allData.forEach(t => {
                this.fields.push(...t.getFields());
            })

        },

        methods: {

            alterInst(inst, index){
                this.allInsts[index] = inst;
                this.updateProvided();
            },

            addInst(){
                this.allInsts.push(null);
                this.updateProvided();
            },

            addOper(){
                if(!this.added) {
                    new Template({
                        name: 'cubic',
                        context: 'mysql',
                        templateDisplay: 'cubic($1)',
                        templateCode: '$1*$1*$1',
                        resultDataType: 'number',
                        params: {
                            $1: new Parameter({
                                dataType: 'number'
                            })
                        }
                    }).as('cubic');
                    this.added = true;
                }
            },

            updateProvided(){
                this.$nextTick(() => {
                    let arr = [];
                    let len = this.allInsts.length;
                    this.allInsts.forEach((i, index) => {
                        arr.push(this.allInsts.slice(0, index));
                    });
                    this.providedInsts = arr;
                });
            }
        },

        watch: {


        }

    }
</script>

<style scoped>

</style>